import styled from "styled-components";

export const AddDepartmentWrapper = styled("div")(() => {
  return {
    overflow: "hidden",
    padding: 0,
    backgroundColor: "var(--background)-color)",
    "& h2": {
      marginBlock: 0,
      fontSize: "24px",
      color: "var(--color-text)",
    },
    "& p": {
      fontSize: "18px",
      color: "var(--color-text-light)",
    },
    "& form": {
      display: "flex",
      flexDirection: "column",
      gap: "var(--flexGap)",
      overflow: "hidden",
    },
    "& input, & select": {
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) / 2)",
      outline: "none",
      border: "1px solid var(--color-primary-hover)",
      backgroundColor: "var(--color-button-secondary)",
      borderRadius: "8px",
      fontWeight: "400",
    },
    "& label": {
      fontFamily: "Poppins",
      fontWeight: 500,
      color: "var(--color-text)",
      marginBlockEnd: "calc(var(--sectionMargin)/2)",
    },
    "& fieldset": {
      flex: 1,
      overflow: "hidden",
      display: "flex",
      gap: "calc(var(--flexGap)/8)",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    "& .submit-button-area": {
      display: "flex",
      gap: "1rem",
      flexWrap: "wrap",
      "@media screen and (max-width: 425px)": {
        flexDirection: "column-reverse",
      },
    },
    "& .cancel-button": {
      border: "1px solid var(--color-primary) ",
      boxShadow: "none !important",
    },
    "& .add-department-success-modal": {
      width: "min(520px, calc(100% - 32px)) !important",
    },
    "& .add-department-success-modal > div": {
      width: "100%",
      margin: 0,
      backgroundColor: "var(--color-background) !important",
      padding: "var(--cardPadding) !important",
      borderRadius: "24px !important",
      boxShadow: "0 24px 60px rgba(41, 49, 112, 0.2) !important",
      border: "1px solid rgba(78, 87, 187, 0.12) !important",
      overflow: "hidden !important",
    },
    "& .add-department-success-modal .icon-box": {
      display: "flex",
      justifyContent: "center",
      marginBottom: "12px",
    },
    "& .add-department-success-modal .title-box h1": {
      margin: "0 0 10px",
      textAlign: "center",
      color: "var(--color-text)",
      fontSize: "34px",
    },
    "& .add-department-success-modal .message-box p": {
      margin: "0 0 24px",
      textAlign: "center",
      color: "var(--color-text-light)",
      lineHeight: 1.7,
      fontSize: "18px",
    },
    "& .add-department-success-modal .call-to-action-button-box": {
      display: "flex",
      justifyContent: "center",
    },
    "& .add-department-success-modal .call-to-action-button-box button": {
      backgroundColor: "var(--color-primary) !important",
      background: "var(--color-primary) !important",
      color: "var(--color-background) !important",
      width: "fit-content",
      minWidth: "140px",
      padding: "0.75rem 1rem",
      borderRadius: ".5rem",
      boxShadow: "0 14px 28px rgba(78, 87, 187, 0.2)",
      border: "none !important",
    },
    "& .add-department-success-modal .call-to-action-button-box button span": {
      color: "#FFFFFF !important",
    },
    "@media screen and (min-width: 768px)": {
      padding: "calc(var(--cardPadding)) 0",
    },
  };
});
